import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ITreeCodeReq } from '../../../models/treeCodes.model'
import { doGetCode, doUpdateCode, doGetCodes } from '../../../store/treeCode.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/treeCode/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

interface IMatch {
  id: string;
}

const SystemTreeCodeEdit: FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { treeCode, isLoading } = useSelector((state: RootState) => state.treeCode);

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  useEffect(() => {
    getCode(id);
  }, [])

  const getCode = async (id: string) => {
    const res = await dispatch(doGetCode(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: ITreeCodeReq) => {
    const res = await dispatch(doUpdateCode(id, req));
    
    switch (res?.status) {
      case 200:
        dispatch(doGetCodes());
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/system/treecode${location.search}`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.code.title3')}
      />
      <Editor
        code={treeCode || null}
        onSubmit={onSubmit}
        cancelPath={null}
      />
      <Footer />
    </div>
  )
}

export default SystemTreeCodeEdit;
